"use client";
import { FC } from "react";
import { BuilderAttributes } from "@/types/builder";
import WistiaPlayer from "@/components/WistiaPlayer";

export type VideoBlock = {
  uuid: string;
  dld?: string;
  dlt?: string;
  textlink?: string;
  playPauseButton?: {
    dld?: string;
    dlt?: string;
    dhd?: string;
    playLabel?: string;
    pauseLabel?: string;
  };
  autoplay?: boolean;
  silentAutoplay?: boolean;
  aspectRatio: number;
} & { attributes: BuilderAttributes };

export const VideoBlock: FC<VideoBlock> = (props) => {
  return (
    <WistiaPlayer
      {...props.attributes}
      uuid={props.uuid}
      dld={props.dld}
      dlt={props.dlt}
      link={props.textlink}
      video_play_pause_button_analytics={props.playPauseButton}
      video_play_button_label={props.playPauseButton?.playLabel}
      video_pause_button_label={props.playPauseButton?.pauseLabel}
      autoplay={props.autoplay}
      silent_auto_play={props.silentAutoplay}
      aspect_ratio={props.aspectRatio}
    />
  );
};
